export const isLoggedIn = () => {
  const isLoggedIn = localStorage.getItem('isLoggedIn');
  return isLoggedIn;
};
